<script setup lang="ts">
const { locale, setLocale } = useI18n()
const appDataStore = useAppDataStore()

const { loading } = storeToRefs(appDataStore)

// 1. Define available locales with 'as const' to fix the TS error
const availableLocales = [
  {
    code: 'en-nz',
    name: 'English',
    icon: 'i-heroicons-flag'
  },
  {
    code: 'mi-nz',
    name: 'Te Reo Māori',
    icon: 'i-twemoji-flag-new-zealand'
  }
] as const

// 2. Transform data for UDropdownMenu
const items = computed(() => [
  availableLocales.map((loc) => ({
    label: loc.name,
    icon: loc.icon,
    checked: loc.code === locale.value,
    type: 'checkbox' as const,
    onSelect: async () => {
      await setLocale(loc.code)
      await nextTick()
      await appDataStore.fetchData(true)
    }
  }))
])
</script>

<template>
  <UDropdownMenu :items="items" :content="{ align: 'end' }">
    <UButton icon="i-lucide-globe" color="neutral" variant="ghost" aria-label="Language" />

    <template #item-leading="{ item }">
      <UIcon :name="item.icon" class="size-4 shrink-0" />
    </template>
  </UDropdownMenu>
</template>
